import globals from '../globals';
const { cdnDomain, PUBLIC_ASSET_URL_BASE } = globals;

const REGEX_SLASHES = /(^\/)|(\/$)/g;
const REGEX_SYMBOL_PARAMS = /((\?|&)(ticker|xid)=[^&#]*|$)/i;
const REGEX_QUERY_SEPARATOR_PREFIX_LEADING = /^(\?|&)*/;

// Paths
const PATHS = {
  porfolioManagerImages: '/assets/images/portfolio-managers/',
  images: 'assets/images/'
};

const trimSlashes = s => s.replace(REGEX_SLASHES, '');

const joinPaths = (...segments) =>
  segments.filter(Boolean).map(trimSlashes).filter(Boolean).join('/');

const getResolver = (...bases) => {
  const base = joinPaths(...bases);
  return (...segments) => `//${joinPaths(base, ...segments)}`;
};

const getResolverCdn = (...bases) => getResolver(cdnDomain, ...bases);

const getPublicAssetResolver = path => getResolver(PUBLIC_ASSET_URL_BASE, path);

const getPublicAssetResolverCdn = path =>
  getResolverCdn(PUBLIC_ASSET_URL_BASE, path);

const profile = ({ symbol, xid }) => {
  const search = (window.location.search || '')
    // replace old ticker/xid param
    // TIAA pages use xid/ticker ambiguously
    .replace(REGEX_SYMBOL_PARAMS, `&ticker=${symbol || xid}`)
    // remove any leading QS separator/prefix
    .replace(REGEX_QUERY_SEPARATOR_PREFIX_LEADING, '');
  const querySeparator = search.length ? '?' : '';
  return `${window.location.origin}${window.location.pathname}${querySeparator}${search}`;
};

const linkToProfile = ({ symbol, xid, channel, UrlDomain = '', UrlPrefix = '' }) => {
  const search = `ticker=${symbol || xid}`;
  const querySeparator = '?';
  const root = window.location.origin;
  let path1 = '/public';
  let path2 = '/investment-performance/investment/profile';

  if (!xid && !symbol) {
    return `${root}`;
  }

  // TIAA IFA rules
  if (channel === 'ifa') {
    path1 = '/private/ifa'; // Unable to validate due to use of legacy screener. Unsure if this will ever run.
  }

  // TIAA MyTIAA rules
  if (channel === 'mytiaa') {
    // MyTIAA incorrectly sets the domain in the app config.
    path1 = '/private/parttools'; // MyTIAA incorrectly sets the urlprefix in the app config.
  }

  // TIAA Microsite rules
  if (channel === 'microsites') {
    path1 = UrlPrefix; // Custom Microsite path fragment based on customer provided in the app config.
  }

  // Overwrite: Localhost test URL support
  if (window.location.href.includes('localhost')) {
    path1 = '/public';
    path2 = '/test/profile.html';
  }

  // Overwrite: Internal domain test URL support
  if (window.location.href.includes('mdgapp')) {
    path1 = '';
    path2 = '/test/profile.html';
  }

  // Overwrite: External domain test URL support
  /* Note: This project's Markit hosted external domains leverage the path fragment /v2, to let traefik
   * know to route request to this application, rather than the legacy Research application. */
  if (window.location.href.includes('v2')) {
    path1 = '';
    path2 = '/v2/test/profile.html';
  }

  return `${root}${path1}${path2}${querySeparator}${search}`;
};

const getQiuPdfUrl = planNumber => {

  const root = globals.qiuPdfDomainUrl;

  const qiuDownloadPath = 'download/qiu';

  return `//${root}/${qiuDownloadPath}?plan=${planNumber}`;
};

const linkToDistribution = ({ planQueryValue, channel }) => {
  const search = `distributionPlan=${planQueryValue}`;
  const querySeparator = '?';

  let root = globals.distributionsPageUrl.default;

  if (channel === 'ifa') {
    root = globals.distributionsPageUrl.ifa;
  } else if (channel === 'mytiaa') {
    root = globals.distributionsPageUrl.myTiaa;
  }

  if (!planQueryValue) {
    return `${root}`;
  }

  return `${root}${querySeparator}${search}`;
};

export const urls = {
  public: {
    asset: getPublicAssetResolver(),
    cdn: { asset: getPublicAssetResolverCdn() }
  },
  portfolioManager: {
    image: getPublicAssetResolver(PATHS.porfolioManagerImages),
    cdn: { image: getPublicAssetResolverCdn(PATHS.porfolioManagerImages) }
  },
  images: {
    image: getPublicAssetResolver(PATHS.images),
    cdn: { image: getPublicAssetResolverCdn(PATHS.images) }
  },
  pages: { profile, linkToProfile, linkToDistribution },
  plans: { getQiuPdfUrl }
};
